import nbsp from '@/assets/js/nbsp'

export default {
  about: 'about',
  aboutAnalysisTitle: 'analysis',
  aboutAnalysisDescription: nbsp('of town planning and zoning documents, feasibility studies'),
  aboutArchitectureTitle: 'architecture',
  aboutArchitectureDescription: nbsp(`
    context-related building design
  `),
  aboutConsultancyTitle: 'consultancy',
  aboutConsultancyContent: nbsp(`
    <p>In our work we place great emphasis on the quality of public space and 
    the functional connection between buildings and the surroundings. Due to 
    this particular approach full of care for space, we have been awarded 
    in numerous urban and architectural competitions that we participated 
    (as team members).</p><p>Another, equally important domain of our activity 
    is consultancy in investment processes related to design. The cradle hard 
    to grasp of government regulations, local resolutions and local environment 
    conditions often make it difficult for investors to start the investment 
    process. Using all our professional knowledge and experience, we try to 
    support our clients in achieving desired success.</p>
  `),
  aboutContent: nbsp(`
    <p>Good architecture cannot exist without a context that complements and 
    defines it. And any architect or town planner should focus first on the 
    human being, as the prospective designed space user. 
    Nowadays people expect from their environments to be first and foremost 
    adequate for living – dwelling, working, shopping, recreation and fun. 
    That is why, ideally, these prospective users should become an essential
    part of the designing process for the project to turn out truly successful. 
    There is no good architecture without well-designed space and well-designed 
    space can’t be conceived without an architect’s involvement.</p>
    <p>These are the principles that we put into action through our designs. 
    We are a team of experienced architects, each one with many years of 
    professional practice and impressive track record in wide range project 
    and analysis works. We specialise in comprehensive solutions in the 
    field of urban planning and architecture.</p>
  `),
  aboutEvaluationTitle: 'evaluations',
  aboutPlanningTitle: 'urban planning',
  aboutPlanningDescription: nbsp(`
    from single city blocks to big scale urban structures
  `),
  aboutPublicTitle: 'public space design',
  aboutPublicDescription: nbsp('streets, squares and parks'),
  aboutStudiesTitle: 'studies',
  aboutStudiesDescription: nbsp(`
    development of large urban structures, local zoning plans, municipality 
    zoning plans
  `),
  aboutTitle: nbsp(`
    Life between building is both relevant and more interesting to look at in 
    the long run than are any combination of colored concrete and staggered 
    building forms
  `),
  aboutTitleAuthor: 'Jan Gehl – architect and town planner',
  aboutTitleAuthorLink: 'https://en.wikipedia.org/wiki/Jan_Gehl',
  analysis: 'analysis',
  architecture: 'architecture',
  associateHeading: 'board / partners',
  companyAddress: 'company\'s address',
  companyInformation: 'company\'s information',
  companyStreetAddress: 'Al. Szucha 2/4 Apt. 39',
  companyStreetAddressAdditional: 'entrance E, floor 3.',
  contact: 'contact',
  cooperationHeading: 'team / co-workers',
  jobHeading: 'employment / internships',
  linksHeading: 'links',
  mapHeading: 'how to get?',
  nextPage: 'next',
  nextProject: 'next',
  planning: 'planning',
  previousPage: 'previous',
  previousProject: 'previous',
  projectCategories: 'project categories',
  projects: 'projects',
  publicSpace: 'public space',
  studioAddress: 'studio address',
  studioStreetAddress: 'Puławska St. 34/2',
  team: 'team',
  info: 'info',
  trustedUs: 'trusted us',
  workedHeading: 'worked with us'
}



// WEBPACK FOOTER //
// ./src/locale/languages/en.js